import ListView from "./ListView/ListView";
import DetailView from "./DetailView/DetailView";

const HistoryMultifunction = () => <p>Riwayat Multiguna</p>;

HistoryMultifunction.ListView = ListView;
HistoryMultifunction.DetailView = DetailView;

export default HistoryMultifunction;
